import { FC } from "react";

import "./description.scss"; // Importing the CSS module for styling the Description component

interface IDescription {
  content: string | JSX.Element | undefined; // The content to be displayed inside the Description component
  className?: string; // Optional additional class names for customizing the Description's styling
}

/**
 * Description component used for displaying text or JSX content with styling.
 *
 * @param {IDescription} props - The properties object for the Description component.
 * @param {string | JSX.Element | undefined} props.content - The content to be displayed inside the Description.
 * @param {string} [props.className=""] - Optional additional class names for the Description.
 *
 * @returns {JSX.Element} The rendered Description component, or an empty fragment if content is not provided.
 */
export const Description: FC<IDescription> = ({ content, className = "" }) => {
  if (!content) {
    // If no content is provided, return an empty fragment
    return <></>;
  }
  return (
    <div className={`simplci-auth-description ${className}`}>
      {/* Render the Description component with a base class and any additional classes */}
      {content}
    </div>
  );
};
